import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    forwardRef
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { ISelectOption } from '../../../../domains/shared/components/select/models/select-option.interface';
import { ISelectSettings } from '../../../../domains/shared/components/select/models/select-settings.interface';
import { CustomControlValueAccessor } from '../../../../domains/shared/utils/custom-control-value-accessor/custom-control-value-accessor';
import {
    PedidoReferenciaData,
    pedidoReferenciasData
} from '../pedido-referencia-data';

@Component({
  selector: 'sgt-pedido-referencia-data-select',
  templateUrl: './pedido-referencia-data-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PedidoReferenciaDataSelectComponent),
      multi: true
    }
  ]
})
export class PedidoReferenciaDataSelectComponent
  extends CustomControlValueAccessor<number>
  implements OnInit {
  @Input() referencias: PedidoReferenciaData[] = pedidoReferenciasData;
  @Input() canSelectNull = true;

  @Input() idReferencia: number;
  @Output() idReferenciaChange = new EventEmitter<number>();

  selectOptions: ISelectOption[] = [];
  selectSettings: Partial<ISelectSettings> = {};


  ngOnInit(): void {
    this.buildOptions();
    this.buildSettings();
  }

  private buildOptions(): void {
    this.selectOptions = this.referencias.map((r) => ({
      id: r.id,
      label: r.nome,
      icon: r.iconClass
    }));
  }

  private buildSettings(): void {
    this.selectSettings = {
      placeholder: 'Nenhuma Referência',
      isDisabled: this._disabled
    };
  }

  onSearch(): void {
    this.emitChange(this.idReferencia);
    this.idReferenciaChange.emit(this.idReferencia);
  }

  onSelectionChange(): void {
    this.emitChange(this.idReferencia);
  }

  protected updateValue(value: number | null): void {
    this.idReferencia = value ?? null;
  }
}
